/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { CollectionGrantFragmentDoc } from "../../mutations/collections.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateHexMutationVariables = Types.Exact<{
  name: Types.Scalars["String"]["input"];
  projectLanguage: Types.InputMaybe<Types.ProjectLanguage>;
  description: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  categoryIds: Types.InputMaybe<
    | ReadonlyArray<Types.Scalars["CategoryId"]["input"]>
    | Types.Scalars["CategoryId"]["input"]
  >;
  statusId: Types.InputMaybe<Types.Scalars["StatusId"]["input"]>;
  kernelSize: Types.InputMaybe<Types.Scalars["KernelSize"]["input"]>;
  kernelImage: Types.InputMaybe<Types.Scalars["KernelImage"]["input"]>;
  getProjectCount?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  collectionId: Types.InputMaybe<Types.Scalars["CollectionId"]["input"]>;
  collectionProjectRole: Types.InputMaybe<Types.ProjectRole>;
  isTour?: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  hexType?: Types.InputMaybe<Types.HexType>;
}>;

export type CreateHexMutation = {
  readonly __typename: "Mutation";
  readonly createHex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly title: string;
    readonly org: {
      readonly __typename: "Org";
      readonly id: c.OrgId;
      readonly projectCount?: number;
    };
  };
};

export type CollectionDetailsForProjectDialogQueryVariables = Types.Exact<{
  collectionId: Types.Scalars["CollectionId"]["input"];
}>;

export type CollectionDetailsForProjectDialogQuery = {
  readonly __typename: "Query";
  readonly collectionById: {
    readonly __typename: "Collection";
    readonly id: c.CollectionId;
    readonly name: string;
    readonly emoji: string | null;
    readonly collectionGrants: ReadonlyArray<{
      readonly __typename: "CollectionGrant";
      readonly id: c.CollectionGrantId;
      readonly role: Types.CollectionRole;
      readonly holder:
        | {
            readonly __typename: "Group";
            readonly groupId: c.GroupId;
            readonly groupName: string;
          }
        | {
            readonly __typename: "IntrinsicGroup";
            readonly intrinsicGroupId: Types.IntrinsicGroupId;
          }
        | {
            readonly __typename: "User";
            readonly name: string | null;
            readonly email: string;
            readonly active: boolean;
            readonly imageUrl: string | null;
            readonly orgRole: Types.OrgRole;
            readonly userId: c.UserId;
          };
    }>;
  };
};

export const CreateHexDocument = /*#__PURE__*/ gql`
  mutation CreateHex(
    $name: String!
    $projectLanguage: ProjectLanguage
    $description: String
    $categoryIds: [CategoryId!]
    $statusId: StatusId
    $kernelSize: KernelSize
    $kernelImage: KernelImage
    $getProjectCount: Boolean = false
    $collectionId: CollectionId
    $collectionProjectRole: ProjectRole
    $isTour: Boolean = false
    $hexType: HexType = PROJECT
  ) {
    createHex(
      name: $name
      projectLanguage: $projectLanguage
      description: $description
      categoryIds: $categoryIds
      statusId: $statusId
      kernelSize: $kernelSize
      kernelImage: $kernelImage
      collectionId: $collectionId
      collectionProjectRole: $collectionProjectRole
      hexType: $hexType
      isTour: $isTour
    ) {
      id
      title
      org {
        id
        projectCount @include(if: $getProjectCount)
      }
    }
  }
`;
export type CreateHexMutationFn = Apollo.MutationFunction<
  CreateHexMutation,
  CreateHexMutationVariables
>;

/**
 * __useCreateHexMutation__
 *
 * To run a mutation, you first call `useCreateHexMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHexMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHexMutation, { data, loading, error }] = useCreateHexMutation({
 *   variables: {
 *      name: // value for 'name'
 *      projectLanguage: // value for 'projectLanguage'
 *      description: // value for 'description'
 *      categoryIds: // value for 'categoryIds'
 *      statusId: // value for 'statusId'
 *      kernelSize: // value for 'kernelSize'
 *      kernelImage: // value for 'kernelImage'
 *      getProjectCount: // value for 'getProjectCount'
 *      collectionId: // value for 'collectionId'
 *      collectionProjectRole: // value for 'collectionProjectRole'
 *      isTour: // value for 'isTour'
 *      hexType: // value for 'hexType'
 *   },
 * });
 */
export function useCreateHexMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateHexMutation,
    CreateHexMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateHexMutation, CreateHexMutationVariables>(
    CreateHexDocument,
    options,
  );
}
export type CreateHexMutationHookResult = ReturnType<
  typeof useCreateHexMutation
>;
export type CreateHexMutationResult = Apollo.MutationResult<CreateHexMutation>;
export type CreateHexMutationOptions = Apollo.BaseMutationOptions<
  CreateHexMutation,
  CreateHexMutationVariables
>;
export const CollectionDetailsForProjectDialogDocument = /*#__PURE__*/ gql`
  query CollectionDetailsForProjectDialog($collectionId: CollectionId!) {
    collectionById(collectionId: $collectionId) {
      id
      name
      emoji
      collectionGrants {
        id
        ...CollectionGrantFragment
      }
    }
  }
  ${CollectionGrantFragmentDoc}
`;

/**
 * __useCollectionDetailsForProjectDialogQuery__
 *
 * To run a query within a React component, call `useCollectionDetailsForProjectDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionDetailsForProjectDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionDetailsForProjectDialogQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useCollectionDetailsForProjectDialogQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionDetailsForProjectDialogQuery,
    CollectionDetailsForProjectDialogQueryVariables
  > &
    (
      | {
          variables: CollectionDetailsForProjectDialogQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectionDetailsForProjectDialogQuery,
    CollectionDetailsForProjectDialogQueryVariables
  >(CollectionDetailsForProjectDialogDocument, options);
}
export function useCollectionDetailsForProjectDialogLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionDetailsForProjectDialogQuery,
    CollectionDetailsForProjectDialogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionDetailsForProjectDialogQuery,
    CollectionDetailsForProjectDialogQueryVariables
  >(CollectionDetailsForProjectDialogDocument, options);
}
export function useCollectionDetailsForProjectDialogSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CollectionDetailsForProjectDialogQuery,
    CollectionDetailsForProjectDialogQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CollectionDetailsForProjectDialogQuery,
    CollectionDetailsForProjectDialogQueryVariables
  >(CollectionDetailsForProjectDialogDocument, options);
}
export type CollectionDetailsForProjectDialogQueryHookResult = ReturnType<
  typeof useCollectionDetailsForProjectDialogQuery
>;
export type CollectionDetailsForProjectDialogLazyQueryHookResult = ReturnType<
  typeof useCollectionDetailsForProjectDialogLazyQuery
>;
export type CollectionDetailsForProjectDialogSuspenseQueryHookResult =
  ReturnType<typeof useCollectionDetailsForProjectDialogSuspenseQuery>;
export type CollectionDetailsForProjectDialogQueryResult = Apollo.QueryResult<
  CollectionDetailsForProjectDialogQuery,
  CollectionDetailsForProjectDialogQueryVariables
>;
